import { useRosteringsQuery } from '@innovamat/glow-api-client';
import { useEffect, useState } from 'react';
import { CSVImport } from '../types';

type Props = {
  organizationId: string | undefined;
  enabled?: boolean;
};

//We can set it to a shorter time, since it is only called on the imports screen.
const SECONDS = 10;
const REFETCH_INTERVAL = SECONDS * 1000;

function useGetCSVImports({ organizationId, enabled = true }: Props) {
  const [refetchInterval, setRefetchInterval] = useState(REFETCH_INTERVAL);

  const query = useRosteringsQuery(
    {
      organizationId: organizationId!,
    },
    {
      enabled: enabled && !!organizationId,
      refetchInterval: refetchInterval,
    }
  );

  useEffect(() => {
    if (query.isError) {
      setRefetchInterval(0);
    }
  }, [query.isError]);

  return { ...query, data: query.data?.rosterings as CSVImport[] | undefined };
}

export { useGetCSVImports };
